/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

import { Maybe } from '.';
import { STATUS_INVITATION_FCUP } from '@/utils/constants';

export const FRIENDS_CUP_PATHS = {
  suscribirse: 'grupo-copa-de-amigos/suscribirse-a-gca',
  tratarPostulacion: '/grupo-copa-de-amigos/tratar-postulacion-o-invitacion',
  invitarDT: 'grupo-copa-de-amigos/invitar-dt-gca',
  expulsarParticipanteGCA: 'grupo-copa-de-amigos/expulsar-participante-gca',
  crearGrupoCopaAmigos: 'grupo-copa-de-amigos/crear-grupo-copa-amigos',
  cambiarNombreGrupoCopaAmigos: 'grupo-copa-de-amigos/cambiar-nombre',
  validarNombreGrupo: '/grupo-copa-de-amigos/validar-nombre',
  verGrupo: 'grupo-copa-de-amigos/ver-grupo-copa-amigos',
  verEquipoRival: 'grupo-copa-de-amigos/ver-equipo-rival',
  sugerirUsuariosGCA: 'grupo-copa-de-amigos/sugerir-usuarios-gca',
  sugerirGruposCopaAmigos: 'grupo-copa-de-amigos/sugerir-grupos-gca',
  init: 'grupo-copa-de-amigos/init-grupo-copa-amigos',
  buscarGrupos: 'grupo-copa-de-amigos/buscar-grupos',
  buscarDTs: 'grupo-copa-de-amigos/buscar-dts',
  sugerirUsuarios: 'grupo-copa-de-amigos/sugerir-usuarios-gca',
  datosBasicos: 'grupo-copa-de-amigos/datos-basicos',
};

export interface FriendCupResponse {
  schemas: {
    /** @description Grupos (mis grupos) */
    GrupoCopaAmigosTO: {
      /** Format: int32 */
      id: number;
      /** Format: int32 */
      idEstadoGrupo: number;
      /** Format: int32 */
      idUsuarioCreador: number;
      /** Format: int32 */
      cantidadDeParticipantes: number;
      nombreGrupo: string;
      nombreCreadorGrupo: string;
      apellidoCreadorGrupo: string;
      participantes: FriendCupResponse['schemas']['ParticipanteGrupoCopaAmigosTO'][];
      nombreEstado: string;
      /** Format: int32 */
      puesto: number;
      /** Format: int32 */
      puntos: number;
      /**
       * @deprecated
       * @description siempre true. Sin sentido por ahora.
       */
      mostrar: boolean;
      rechazado?: boolean;
      estadoParticipante: keyof typeof STATUS_INVITATION_FCUP;
      /** @enum {string} */
      estadoGrupo: 'TODOS' | 'INCOMPLETO' | 'COMPLETO' | 'ELIMINADO';
    };
    ParticipanteGrupoCopaAmigosTO: {
      /** Format: int32 */
      id: number;
      /** Format: int32 */
      idUsuario: number;
      nombres: string;
      apellido: string;
      /** Format: int32 */
      idUsuarioCreador: number;
      /** Format: byte */
      // + "<li>PENDIENTE_ACEPTAR_DUENIO(1, \"Pendiente Aceptar Dueño\")</li>\r\n"
      // + "<li>PARTICIPANDO(2, \"Participando\")</li>\r\n"
      // + "<li>ELIMINADO(3, \"Eliminado\")</li>\r\n"
      // + "<li>RECHAZADO(4,\"Invitación rechazada\") (descripción incorrecta: POSTULACION rechazada)</li>\r\n"
      // + "<li>PENDIENTE_ACEPTAR_INVITADO(5, \"Pendiente Aceptar Invitado\")</li>\r\n"
      // + "<li>RECHAZA_INVITADO(6,\"Invitación rechazada por Invitado\")</li>"
      idEstado: number;
      /** Format: date-time */
      fechaParticipacion: string;
      nombreEquipo: string;
      puntos: number[] | number;
      /** Format: int32 */
      idGrupo: number;
      mostrar: boolean;
      /** Format: int32 */
      puntosAcumulados: number;
      nombreYApellido: string;
      provincia?: string;
      /** Format: byte */
      idEstadoParticipanteGrupoIsenbeck: string;
      /** @enum {string} */
      estadoParticipante:
        | 'Pendiente Aceptar Dueño'
        | 'Participando'
        | 'Eliminado'
        | 'Invitación rechazada'
        | 'Pendiente Aceptar Invitado'
        | 'Invitación rechazada por Invitado';
    };
    ResponseTratarPostulanteGCA: {
      /**
       * true / false.
       * @description Indica si hubo un error o no.
       */
      estado: boolean;
      /**
       * mensaje de error
       * @description si estado == false.
       */
      mensaje?: string;
      /**
       * código de error (opcional)
       * Format: int32
       * @description si estado == false.
       */
      codError?: number;
      grupo?: FriendCupResponse['schemas']['GrupoCopaAmigosTO'];
      status?: boolean;
    };
    ResponseSuscribirseAGCA: {
      /**
       * true / false.
       * @description Indica si hubo un error o no.
       */
      estado: boolean;
      /**
       * mensaje de error
       * @description si estado == false.
       */
      mensaje?: string;
      /**
       * código de error (opcional)
       * Format: int32
       * @description si estado == false.
       */
      codError?: number;
      grupoInscripto?: boolean;
    };
    ResponseBase: {
      /**
       * true / false.
       * @description Indica si hubo un error o no.
       */
      estado: boolean;
      /**
       * mensaje de error
       * @description si estado == false.
       */
      mensaje?: string;
      /**
       * código de error (opcional)
       * Format: int32
       * @description si estado == false.
       */
      codError?: number;
      invitacionConvertidaEnAceptacion?: boolean;
    };
    ResponseExpulsarParticipanteGCA: {
      /**
       * true / false.
       * @description Indica si hubo un error o no.
       */
      estado: boolean;
      /**
       * mensaje de error
       * @description si estado == false.
       */
      mensaje?: string;
      /**
       * código de error (opcional)
       * Format: int32
       * @description si estado == false.
       */
      codError?: number;
      status?: boolean;
    };
    /** @description <br> Errores posibles: <br><li>GRUPO_COPA_AMIGOS_FINALIZADO_CREAR(2608,"No se pueden crear el Equipo.")</li><li>EXCLUIDO_POR_SER_EXTRANJERO(3507,"La participaci\u00f3n en esta competencia es exclusiva para DTs argentinos"),</li><li>GRUPO_COPA_AMIGOS_SIN_EQUIPO_A		(1315 ,"Para participar debés tener armado tu equipo en Gran DT Primera División.")</li><li>GRUPO_COPA_AMIGOS_NOMBRE_NULO				(1605, "Para crear un Equipo, tenes que escribir un nombre."),</li><li>GRUPO_COPA_AMIGOS_NOMBRE_LARGO 			(1606, "El nombre del Equipo no puede superar los 25 caracteres."),</li><li>GRUPO_COPA_AMIGOS_EXISTE					(1603, "Ya existe un Equipo con el mismo nombre. Por favor, modificalo."),</li><li>GRUPO_COPA_AMIGOS_NOMBRE_INVALIDO			(1601, "El nombre del Equipo contiene palabras prohibidas."),</li><li>GRUPO_COPA_AMIGOS_NOMBRE_INVALIDO2	(2625, "El nombre del equipo no puede contener caracteres especiales"),</li> */
    ResponseCrearGrupo: {
      /**
       * true / false.
       * @description Indica si hubo un error o no.
       */
      estado: boolean;
      /**
       * mensaje de error
       * @description si estado == false.
       */
      mensaje?: string;
      /**
       * código de error (opcional)
       * Format: int32
       * @description si estado == false.
       */
      codError?: number;
      /**
       * Format: int32
       * @description id del grupo creado
       */
      idGrupo?: number;
      /** @description nombre del grupo creado */
      nombre?: string;
      /** @description La fecha en la que va a comenzar el GCA, valores: 'Fecha XX' ó ' próxima fecha' */
      txtFechaReemplazar?: string;
    };
    /**
     * Fecha
     * @description fechas que juegan GCA
     * @example {"id":992,"nombre":"Fecha
     *         22","orden":21,"isPublicada":false}
     */
    FechaTO: {
      /**
       * id de fecha
       * Format: int32
       */
      id?: number;
      /** nombre de fecha */
      nombre?: string;
      /**
       * orden de fecha
       * Format: int32
       */
      orden?: number;
      /**
       * idRnkPublicado
       * Format: int32
       * @description ojo, solo usar en GrupoCopaAmigos
       */
      idRnkPublicado?: number;
      publicada?: boolean;
    };
    /** @description Puntaje de todo el grupo. */
    PosGrupoCopaAmigosTO: {
      /** Format: int32 */
      ordenFecha?: number;
      puntos?: number;
      /** Format: int32 */
      posicion?: number;
    };
    PosicionRankingTO: {
      /** Format: int32 */
      puestoDT?: number;
      /** Format: int32 */
      puntosDT?: number;
      nombreEquipoDT?: string;
      apellidoDT?: string;
      nombreDT?: string;
      /** Format: int32 */
      idProvincia?: number;
      /** Format: int32 */
      idUsuario?: number;
    };
    /** @description Por cada 'orden de fecha' devuelve un Objeto PuntosFechaTO, que contiene los puntos POR PARTICIPANTE del grupo */
    PuntosFechaTO: {
      /** Format: int32 */
      ordenFecha?: number;
      puntos?: FriendCupResponse['schemas']['PosicionRankingTO'][];
    };
    ResponseVerGrupoGCA: {
      /**
       * true / false.
       * @description Indica si hubo un error o no.
       */
      estado: boolean;
      /**
       * mensaje de error
       * @description si estado == false.
       */
      mensaje?: string;
      /**
       * código de error (opcional)
       * Format: int32
       * @description si estado == false.
       */
      codError?: number;
      /** @description (sólo administrar grupo) <br>pendientes de aceptar por el dueño */
      queAunNoAceptaste?: FriendCupResponse['schemas']['ParticipanteGrupoCopaAmigosTO'][];
      /**
       * @description (sólo administrar grupo) <br>cant. solicitudes pendientes, como string.<br>ej: '1 solicitud'
       * @example 2 solicitudes
       */
      cantSolPendientes?: string;
      fechaEqIncompleto?: FriendCupResponse['schemas']['FechaTO'];
      /**
       * @description (grupo completo) Fecha en que comienza el grupo, upppercase(usable para determinar si el grupo es COMPLETO)
       * @example FECHA 18
       */
      fechaInicioEquipo?: string;
      /**
       * Format: int32
       * @description (grupo completo) fecha en que comienza el grupo, orden
       * @example 17
       */
      ordenFechaInicioEquipo?: number;
      /** @description (grupo completo) Combo fechas si NO es administrar GCA. */
      fechasCmbVerEquipo2?: FriendCupResponse['schemas']['FechaTO'][];
      /** @description Puntaje de todo el grupo. */
      puntajes?: FriendCupResponse['schemas']['PosGrupoCopaAmigosTO'][];
      /** @description Por cada 'orden de fecha' devuelve un Objeto PuntosFechaTO, que contiene los puntos POR PARTICIPANTE del grupo */
      nuevoPuntosEquipo?: {
        [key: string]: FriendCupResponse['schemas']['PuntosFechaTO'];
      };
      /** @description obvio. Orden: vos sos el primero siempre. */
      participantesGrupo?: FriendCupResponse['schemas']['ParticipanteGrupoCopaAmigosTO'][];
      /** @description obvio */
      nombreGrupo?: string;
      /**
       * Format: int32
       * @description obvio
       */
      cantidadParticipantes?: number;
      pendientesAceptarPorInvitado?: FriendCupResponse['schemas']['ParticipanteGrupoCopaAmigosTO'][];
    };
    /** @description DTO de jugador torneo, para mostrar el equipo al rival */
    JugadorMiniLigaTO: {
      /** Format: int32 */
      id?: number;
      nombres?: string;
      apellido?: string;
      posicion?: FriendCupResponse['schemas']['PosicionTO'];
      nombreCompleto?: string;
      status?: string;
      capitan?: boolean;
      /** @deprecated */
      nombreEquipo?: string;
    };
    PosicionTO: {
      /** Format: int32 */
      id?: number;
      nombre?: string;
      nombreCorto?: string;
      /** Format: int32 */
      orden?: number;
    };
    ResponseVerEquipoGCA: {
      /**
       * true / false.
       * @description Indica si hubo un error o no.
       */
      estado: boolean;
      /**
       * mensaje de error
       * @description si estado == false.
       */
      mensaje?: string;
      /**
       * código de error (opcional)
       * Format: int32
       * @description si estado == false.
       */
      codError?: number;
      /**
       * @description Camiseta de {idUsuarioDT} (el usuario rival)
       * @example 1,3,fff,eee,1
       */
      camiseta?: string;
      /** @description 'Nombre de equipo' de {idUsuarioDT} (el usuario rival) */
      nEquipo?: string;
      /** @description Nombre y apellido del usuario rival ({idUsuarioDT}) */
      nombre?: string;
      /** @description jugadores del usuario rival ({idUsuarioDT}) */
      equipo?: FriendCupResponse['schemas']['JugadorMiniLigaTO'][];
    };
    ResponseCheckNombre: {
      /**
       * true / false.
       * @description Indica si hubo un error o no.
       */
      estado: boolean;
      /**
       * mensaje de error
       * @description si estado == false.
       */
      mensaje?: string;
      /**
       * código de error (opcional)
       * Format: int32
       * @description si estado == false.
       */
      codError?: number;
      /** @description Nombre utilizable */
      nombreOk?: boolean;
    };
    ResponseSugerirUsuariosGCA: {
      /**
       * true / false.
       * @description Indica si hubo un error o no.
       */
      estado: boolean;
      /**
       * mensaje de error
       * @description si estado == false.
       */
      mensaje?: string;
      /**
       * código de error (opcional)
       * Format: int32
       * @description si estado == false.
       */
      codError?: number;
      usuariosSugeridos?: FriendCupResponse['schemas']['UsuarioDTReducidoTO'][];
    };
    /** @description usuario resultado de búsquedas (GCA/ML/TDA)<br>También es el resultado de sugerencias de usuarios para GCA/ML/TDA. */
    UsuarioDTReducidoTO: {
      /**
       * Format: int32
       * @description obvio
       */
      idUsuario?: number;
      /** @description obvio */
      nombres?: string;
      /** @description obvio */
      apellido?: string;
      /** @description obvio */
      club?: string;
      /** @description obvio */
      provincia?: string;
      /** @description obvio */
      nombreEquipo: string;
      /**
       * Format: int32
       * @description obvio
       */
      edad?: number;
      /**
       * Format: int32
       * @description (sólo búsquedas, no viene en sugerencias) <br>idEstado cambia según sea ML/TDA/GCA. <br><br>Estados TDA: idEstado/nombreEstado en TDA. <br> <b>idEstado es correcto, nombreEstado sólo usable en TDA</b><br> Viene de EEstadoParticipanteTorneoAmigos  	<li> 0: estado inexistente (no participa en el TDA) </li> 	<li> PENDIENTE_ACEPTAR_DUENIO( 1, "Pendiente Aceptar Dueño"),</li> 	<li>PARTICIPANDO( 2, "Participando"),</li> 	<li>ELIMINADO( 3, "Eliminado"), </li>	<li>PENDIENTE_ACEPTAR_INVITADO( 4, "Pendiente Aceptar Invitado"), </li>	<li>RECHAZADO( 5, "rechazado por el dueño"), </li>	<li>RECHAZA_INVITADO( 6, "Invitación rechazada por Invitado")</li><br>Estados  ML: <br> idEstado para ML:<li>PENDIENTE_ACEPTAR_DUENIO((byte)1, "Pendiente Aceptar Dueño")</li> <li>PARTICIPANDO((byte)2, "Participando")</li> <li>ELIMINADO((byte)3, "Eliminado")</li> <li>RECHAZADO((byte)4,"Invitación rechazada")</li> <li>PENDIENTE_ACEPTAR_INVITADO((byte)5, "Pendiente Aceptar Invitado")</li> <li>RECHAZA_INVITADO((byte)6,"Invitación rechazada por Invitado")</li><br>Estados GCA: idEstado para GCA es igual a ML.
       */
      idEstado?: number;
      /** @description <br>Este campo sólo es usable para TDA <br>idEstado/nombreEstado en TDA. <br> <b>idEstado es correcto, nombreEstado sólo usable en TDA</b><br> Viene de EEstadoParticipanteTorneoAmigos  	<li> 0: estado inexistente (no participa en el TDA) </li> 	<li> PENDIENTE_ACEPTAR_DUENIO( 1, "Pendiente Aceptar Dueño"),</li> 	<li>PARTICIPANDO( 2, "Participando"),</li> 	<li>ELIMINADO( 3, "Eliminado"), </li>	<li>PENDIENTE_ACEPTAR_INVITADO( 4, "Pendiente Aceptar Invitado"), </li>	<li>RECHAZADO( 5, "rechazado por el dueño"), </li>	<li>RECHAZA_INVITADO( 6, "Invitación rechazada por Invitado")</li> */
      nombreEstado?: string;
      /**
       * @description String (CSV) para representar la camiseta
       * @example 3,4,e92121,ab1414,3
       */
      camiseta?: string;
      /** @description obvio */
      localidad?: string;
      /** @description url a foto de perfil */
      fotoPerfil?: string;
      /** Format: int32 */
      id: number;
    };
    ResponseSugerirGruposCopaAmigos: {
      /**
       * true / false.
       * @description Indica si hubo un error o no.
       */
      estado: boolean;
      /**
       * mensaje de error
       * @description si estado == false.
       */
      mensaje?: string;
      /**
       * código de error (opcional)
       * Format: int32
       * @description si estado == false.
       */
      codError?: number;
      gruposSugeridos?: FriendCupResponse['schemas']['GrupoCopaAmigosTO'][];
    };
    /** @description archivo top 10 (general) de GCA: [ENTORNO]/ganadores/topGral_grupoCA_{idRnkST}.json */
    ItemRankingGrupoCopaAmigosTO: {
      /** Format: int32 */
      id?: number;
      nombreGrupo?: string;
      /** Format: int32 */
      puesto?: number;
      /** Format: int32 */
      puntos?: number;
      descalificado?: boolean;
    };
    RankingGrupoCopaAmigosTO: FriendCupResponse['schemas']['ItemRankingGrupoCopaAmigosTO'][];
    ResponseInitGrupoGCA: {
      /**
       * true / false.
       * @description Indica si hubo un error o no.
       */
      estado: boolean;
      /**
       * mensaje de error
       * @description si estado == false.
       */
      mensaje?: string;
      /**
       * código de error (opcional)
       * Format: int32
       * @description si estado == false.
       */
      codError?: number;
      /** @description value '1' o undefined. <br>Creo que solo lo usa Desktop, no usar en mobile<br> Viene de una redirección desde un mail (invitación). Muestra popup invitación. <br> Sólo una vez por sesión. */
      popInsc?: string;
      /** @description  El usuario no participó, 	ya no se puede inscribir (veda última fecha) y todavía no se muestran los ganadores.<> (!isUsuarioParticipando && noEstaAbiertaLaInscripcion 					&& !sePublicoLaUltimaFechaCopa)<br><br>Se utiliza para patear al usuario que no participó a la preHome con 'finalizaron' */
      vedaUltFechaSinParticipar?: boolean;
      /** @description Se configuró la activación en BackDT. */
      configurado?: boolean;
      /** @description obvio */
      inscripcionAbierta?: boolean;
      /** @description el usuario en sesión tiene equipo F11 */
      tieneEquipo?: boolean;
      /**
       * @description Cant. de grupos participando en los que NO sos dueño.<br>Texto tipo '3 equipos'. <br> undefined si es cero.
       * @example 1 equipo
       */
      cantGruposParticipando?: string;
      /** @description cant. grupos a los que te invitaron (formato string).<br><br>ej: '3 equipos'. */
      cantGruposQueTeInv?: string;
      /**
       * Format: int32
       * @description cant. grupos a los que te invitaron (formato int).<br><br>ej: '3 equipos'.
       */
      iCantGruposQueTeInv?: number;
      /** @description grupos que tenés pendiente de aceptar como invitado. */
      gruposPend?: FriendCupResponse['schemas']['GrupoCopaAmigosTO'][];
      gruposPendAceptacionDuenio?: FriendCupResponse['schemas']['GrupoCopaAmigosTO'][];
      /** @description fechas que juegan GCA */
      fechasCA?: FriendCupResponse['schemas']['FechaTO'][];
      /** @description cuidado! nombre engañoso.<br> Puede ser:<li>Última fecha de copa (si todavía estamos jugando copa)</li><li> '---' (si copa terminó)</li> */
      fechaActual?: string;
      /** @description cuidado! nombre engañoso. <br>Indica si la inscripción no está abierta. */
      fechaActualGDTEnVeda?: boolean;
      grupoGanador?: FriendCupResponse['schemas']['ItemRankingGrupoCopaAmigosTO'];
      /** @description Grupos (mis grupos) */
      grupos?: FriendCupResponse['schemas']['GrupoCopaAmigosTO'][];
      /** @description ver instanciaHeader. */
      nombreFechaHeader?: string;
      /** @description obvio y sin sorpresas */
      nombreFechaInicioCopa?: string;
      /** @description Texto con el día que comienza la activación. ejemplo: "El sábado 4 a las 19.00 hs" */
      txtFechaHoraInicio?: string;
      /**
       * Format: int32
       * @description Escenario que presenta el header de la página (desktop).<br><li>1: 'Arranca en la Fecha X. El viernes X a las x.' (cuando aún no arrancó la primer fecha)</li><li>2: 'arranca la fecha x' (48hs antes de la veda)</li><li>3: 'se está jugando la fecha x' (fecha x en veda, o veda 'extendida')</li><li>4: terminó la fecha x</li><li></li><li></li>
       */
      instanciaHeader?: number;
      /** @description Usuario pertenece al grupo ganador (mis grupos) */
      pertenezcoAlGrupoGanador?: boolean;
      /**
       * Format: int32
       * @description última versión de <b>ranking</b> publicada (sólo para esta activación)
       */
      ultimaVersionPublicada?: number;
      /**
       * Format: double
       * @description No creo que sea útilcant. total de páginas para 'grupos', (cantPorPagina=5) (mis grupos)
       */
      totalPagGA?: number;
      /** @description fecha a jugar cuando se crea el equipo */
      txtFechaComienzoProximoGrupoCreado?: string;
    };
    PageResultadoBusquedaGrupoTO: {
      objectList: FriendCupResponse['schemas']['ItemResultadoBusquedaGrupoTO'][];
      /** Format: int32 */
      pageCount?: number;
      /** Format: int32 */
      currentPage?: number;
      hasNext?: boolean;
      hasPrevious?: boolean;
      pagerInfo?: FriendCupResponse['schemas']['PagerInfo'];
      /** Format: int32 */
      objectCount?: number;
    };
    PagerInfo: {
      /** Format: int32 */
      length?: number;
      /** Format: int32 */
      init?: number;
    };
    ResponseBuscarGrupoCopaAmigos: {
      /**
       * true / false.
       * @description Indica si hubo un error o no.
       */
      estado: boolean;
      /**
       * mensaje de error
       * @description si estado == false.
       */
      mensaje?: string;
      /**
       * código de error (opcional)
       * Format: int32
       * @description si estado == false.
       */
      codError?: number;
      page?: FriendCupResponse['schemas']['PageResultadoBusquedaGrupoTO'];
      /** Format: int32 */
      cantPorPagina?: number;
      /** Format: int32 */
      paginaActual?: number;
      nombreGrupo?: string;
      nombreCreador?: string;
      apellidoCreador?: string;
    };
    ItemResultadoBusquedaGrupoTO: {
      /** Format: int32 */
      id: number;
      nombreGrupo: string;
      nombreCreadorGrupo: string;
      apellidoCreadorGrupo: string;
      mostrar?: boolean;
      /** Format: int32 */
      idEstado: number;
      // TODO: servicios faltantes
      cantidadDeParticipantes: number;
      provincia?: string;
    };
    ResponseBuscarDTsGenerico: {
      /**
       * true / false.
       * @description Indica si hubo un error o no.
       */
      estado: boolean;
      /**
       * mensaje de error
       * @description si estado == false.
       */
      mensaje?: string;
      /**
       * código de error (opcional)
       * Format: int32
       * @description si estado == false.
       */
      codError?: number;
      /**
       * dos maneras de indicar un error
       * @description puede ser ErrorTO2 o Boolean. Evitar. Es problemático.
       */
      error?: { [key: string]: unknown };
      usuarios?: FriendCupResponse['schemas']['UsuarioDTReducidoTO'][];
    };
  };
}

export interface BasicDataGDA {
  estado: boolean;
  nombre: string;
  nombreDuenio: string;
  apellidoDuenio: string;
  fechaInicio: {
    id: number;
    nombre: string;
    orden: number;
    publicada: boolean;
  };
  idEstadoParticipante: number;
}

export interface operations {
  /** Alias de '/grandt/mobileWM.html?_action=tratarPostulanteGCA'<br> Según tipoAccion: acepta/ rechaza invitación/postulación.<br> ACC_ACEPTAR_POSTULACION_DSD_INV se usa si 		estás invitando y detectás que ya está postulando a tu torneo. Ahí mandás 'idUsuario'.<br> Ojo! usás (idParticipante, idUsuario o nada) según tipoAccion, ver doc abajo.<br> Errores: <li>EXCLUIDO_POR_SER_EXTRANJERO(3507,"La participaci\u00f3n en esta competencia es exclusiva para DTs argentinos")</li> <li>GRUPO_COPA_AMIGOS_SIN_EQUIPO	(2626, "Ten\u00E9s que tener equipo de Primera División para participar de la Copa de Amigos.")</li> <li>GRUPO_COPA_AMIGOS_LLENO	(1613,"El Equipo se encuentra lleno.")</li> <li>GRUPO_COPA_AMIGOS_FECHAS_CONF_FUERA(1615,"¡Lo lamentamos! Pero ya finaliz\u00F3 el per\u00EDodo de confirmaci\u00F3n.")</li> <li>GRUPO_COPA_AMIGOS_FECHAS(1614,"Inconsistencia en las fechas.")</li> <li>GRUPO_COPA_AMIGOS_NO_PARTICIPA_TORNEO			(1610, "El usuario no participa en el Equipo espec\u00EDficado.")</li> <li>GRUPO_COPA_AMIGOS_USUARIO_NO_ES_DUENIO	(2612,"El DT no es Administrador del Equipo.")</li><li>GRUPO_COPA_AMIGOS_EXP_DUENO(2618,"No se puede rechazar al dueño del Equipo.")</li> <li>GRUPO_COPA_AMIGOS_YA_RECHAZADO(2617,"Ya ha sido rechazado de este Equipo.")</li> <li>GRUPO_COPA_AMIGOS_SIN_EQUIPO_A		(1315 ,"Para participar debés tener armado tu equipo en Gran DT Primera División."),//<<código 1315 (no cambiar)</li> <li>GRUPO_COPA_AMIGOS_FINALIZADO_ACEPT	(2611,"No se pueden aceptar nuevos participantes. Ya terminó el período de inscripción."),</li>  <li>GRUPO_COPA_AMIGOS_USUARIO_PARTICIPANDO	(1607, "Ya est\u00E1s participando de \u00E9ste Equipo."),</li> <li>GRUPO_COPA_AMIGOS_USUARIO_PENDIENTE_ACEPTAR_DUENIO	(2607, "Ya est\u00E1s postulado a este Equipo, actualmente est\u00E1s a la espera de que te acepte el dueño."),</li> <li>GRUPO_COPA_AMIGOS_USUARIO_PENDIENTE_ACEPTAR_INV	(2623, "Ten\u00E9s una invitaci\u00F3n pendiente para el Equipo al cual quer\u00E9s postularte ¿Quer\u00E9s aceptarla?"),</li> <li>GRUPO_COPA_AMIGOS_YA_INVITADO	(2622, "El usuario seleccionado tiene pendiente una invitaci\u00F3n a este Equipo."),</li> */
  tratarPostulacion: {
    parameters: {
      query: {
        /** <li>ACC_ACEPTAR_POSTULACION = 1</li> <li>ACC_RECHAZAR_POSTULACION = 2</li> <li>ACC_ACEPTAR_INVITACION = 3</li> <li>ACC_RECHAZAR_INVITACION = 4</li> <li>ACC_ACEPTAR_POSTULACION_DSD_INV = 5</li> */
        tipoAccion: number;
        /** id de Grupo */
        idGrupo: number;
        /** (si ACC_RECHAZAR_POSTULACION/ACC_ACEPTAR_POSTULACION) */
        idParticipante?: number;
        /** (si ACC_ACEPTAR_POSTULACION_DSD_INV) */
        idUsuario?: number;
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          'application/json': FriendCupResponse['schemas']['ResponseTratarPostulanteGCA'];
        };
      };
    };
  };
  /** envia postulación */
  suscribirse: {
    parameters: {
      query: {
        idGrupo: number;
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          'application/json': FriendCupResponse['schemas']['ResponseSuscribirseAGCA'];
        };
      };
    };
  };
  invitarDT: {
    parameters: {
      query: {
        idGrupo: number;
        idUsuarioDT: number;
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          'application/json': FriendCupResponse['schemas']['ResponseBase'];
        };
      };
    };
  };
  expulsarParticipanteGCA: {
    parameters: {
      query: {
        idGrupo: number;
        idParticipante: number;
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          'application/json': FriendCupResponse['schemas']['ResponseExpulsarParticipanteGCA'];
        };
      };
    };
  };
  crearGrupoCopaAmigos: {
    parameters: {
      query: {
        nombreGrupo: string;
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          'application/json': FriendCupResponse['schemas']['ResponseCrearGrupo'];
        };
      };
    };
  };
  verGrupo: {
    parameters: {
      query: {
        idGrupo: number;
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          'application/json': FriendCupResponse['schemas']['ResponseVerGrupoGCA'];
        };
      };
    };
  };
  verEquipoRival: {
    parameters: {
      query: {
        idGrupo: number;
        idUsuarioDT: number;
        ordenFecha: number;
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          'application/json': FriendCupResponse['schemas']['ResponseVerEquipoGCA'];
        };
      };
    };
  };
  /** Valida el nombre. <br> códigos de error:<li>GRUPO_COPA_AMIGOS_NOMBRE_NULO	(1605, "Ingresá el nombre de tu equipo.")</li> <li>GRUPO_COPA_AMIGOS_NOMBRE_LARGO 	(1606, "El nombre del Equipo no puede superar los 25 caracteres.")</li> <li>GRUPO_COPA_AMIGOS_EXISTE		(1603, "Ya existe un Equipo con el mismo nombre. ")</li> <li>GRUPO_COPA_AMIGOS_NOMBRE_INVALIDO	(1601, "El nombre del Equipo contiene palabras prohibidas.")</li> <li>GRUPO_COPA_AMIGOS_NOMBRE_INVALIDO2	(2625, "El nombre del equipo no puede contener caracteres especiales")</li> */
  validarNombre: {
    parameters: {
      query: {
        nombre: string;
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          'application/json': FriendCupResponse['schemas']['ResponseCheckNombre'];
        };
      };
    };
  };
  sugerirUsuariosGCA: {
    parameters: {
      query: {
        cantMaxResultados?: number;
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          'application/json': FriendCupResponse['schemas']['ResponseSugerirUsuariosGCA'];
        };
      };
    };
  };
  sugerirGruposCopaAmigos: {
    parameters: {
      query: {
        cantMaxResultados?: number;
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          'application/json': FriendCupResponse['schemas']['ResponseSugerirGruposCopaAmigos'];
        };
      };
    };
  };
  /** pedido inicial */
  initGCA: {
    responses: {
      /** OK */
      200: {
        content: {
          'application/json': FriendCupResponse['schemas']['ResponseInitGrupoGCA'];
        };
      };
    };
  };
  buscarGrupos: {
    parameters: {
      query: {
        nombreGrupo?: string;
        nombreCreador?: string;
        apellidoCreador?: string;
        paginaActual?: number;
        cantPorPagina?: number;
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          'application/json': FriendCupResponse['schemas']['ResponseBuscarGrupoCopaAmigos'];
        };
      };
    };
  };
  /** Búsqueda de Usuarios por full text search sobre 'apellido + nombre' <br><br>Recibe: 	<li> search: texto libre de búsqueda<li>	<li> idTDA/idGrupo/idML (dependiendo del módulo) </li><br> La búsqueda: 	<li>es fuzzy</li> <li>es un 'AND' entre los términos</li>	<li>prioriza el apellido (da mayor SCORE ¿pq está antes o pq está dos veces?)</li> */
  buscarDTs: {
    parameters: {
      query: {
        search?: string;
        idGrupo?: number;
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          'application/json': FriendCupResponse['schemas']['ResponseBuscarDTsGenerico'];
        };
      };
    };
  };
  /** CAMBIO DE NOMBRE COPA ADMIN*/
  cambiarNombre: {
    parameters: {
      query: {
        nombre: string;
        idGrupo: number;
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          'application/json': FriendCupResponse['schemas']['ResponseBase'];
        };
      };
    };
  };
}

export interface external {}

export type SuggestedGroupsResponse =
  FriendCupResponse['schemas']['ResponseSugerirGruposCopaAmigos'];

export type SubscribeGroupResponse =
  FriendCupResponse['schemas']['ResponseSuscribirseAGCA'];

export type RequestGroupsSearch =
  operations['buscarGrupos']['parameters']['query'];

export type GroupsResultResponse =
  FriendCupResponse['schemas']['ResponseBuscarGrupoCopaAmigos'];

export type ItemResultGroupsResponse =
  FriendCupResponse['schemas']['ItemResultadoBusquedaGrupoTO'];

export type RequestSearchDTs = operations['buscarDTs']['parameters']['query'];

export type DTsResultResponse =
  FriendCupResponse['schemas']['ResponseBuscarDTsGenerico'];

export type ItemResultDTsResponse =
  FriendCupResponse['schemas']['UsuarioDTReducidoTO'];

export type InitFCup = Maybe<
  FriendCupResponse['schemas']['ResponseInitGrupoGCA']
>;

export type FCupViewTeamResponse =
  FriendCupResponse['schemas']['ResponseVerGrupoGCA'];

export type FCupDate = FriendCupResponse['schemas']['FechaTO'];

export type FCupParticipants =
  FriendCupResponse['schemas']['ParticipanteGrupoCopaAmigosTO'];

export type FCupTeamScore =
  FriendCupResponse['schemas']['PosGrupoCopaAmigosTO'][];

export type RecommendedListFCup =
  FriendCupResponse['schemas']['ResponseSugerirGruposCopaAmigos']['gruposSugeridos'];

export type ListItemFCup = FriendCupResponse['schemas']['GrupoCopaAmigosTO'];

export type ListFCup = FriendCupResponse['schemas']['GrupoCopaAmigosTO'][];

export type CreateTeamResponse =
  FriendCupResponse['schemas']['ResponseCrearGrupo'];

export type CheckNameResponse =
  FriendCupResponse['schemas']['ResponseCheckNombre'];

export type ResponseExpelMemberFCup =
  FriendCupResponse['schemas']['ResponseExpulsarParticipanteGCA'];

export type ResponseManagePostulantFCup =
  FriendCupResponse['schemas']['ResponseTratarPostulanteGCA'];

export type RequestManagePostulantFCup =
  operations['tratarPostulacion']['parameters']['query'];

export type RequestChangeNameFCup =
  operations['cambiarNombre']['parameters']['query'];

export type ResponseTop10 =
  FriendCupResponse['schemas']['RankingGrupoCopaAmigosTO'];

export type ScoreByMatchDate =
  FriendCupResponse['schemas']['PosicionRankingTO'];

export type ItemTop10 =
  FriendCupResponse['schemas']['ItemRankingGrupoCopaAmigosTO'];

export type STATUS_NUMBER_FCUP =
  FriendCupResponse['schemas']['GrupoCopaAmigosTO']['estadoGrupo'];
